import { Component, Input } from '@angular/core';

@Component({
    selector: 'xm-promotions',
    templateUrl: './promotions.html',
    styleUrls: ['./promotions.scss'],
    standalone: false
})
export class XmPromotionsComponent {
    @Input() public header: string;
    @Input() public subheader?: string;
    @Input() public imageOptions: MediaImageOptions;
}
